import React from 'react'

import { getMoneyClasses, getMoneyText } from 'components/members/utils'
import { membersReimbursements } from 'rails_routes'
import { Table } from 'slab'
import { type MemberReimbursement } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import { TransactionCategoryBadge } from '../TransactionCategoryBadge/TransactionCategoryBadge'

export const ReimbursementRow: React.FC<{ reimbursement: MemberReimbursement }> = ({ reimbursement }) => {
  const { assign } = useWindowLocation()

  return (
    <Table.Row
      key={reimbursement.id}
      onClick={() => assign(membersReimbursements.show({ id: reimbursement.id }))}
      accessibleLabel={`View details for reimbursement ${reimbursement.id}`}
    >
      <Table.Cell>
        <div className='flex flex-col'>
          <span className='body text-subdued text-nowrap'>
            Pending
          </span>
          {!reimbursement.has_receipts && (
            <span className='caption font-semibold text-red-400'>
              Missing receipt
            </span>
          )}
        </div>
      </Table.Cell>
      <Table.Cell>
        <span className='body text-main'>
          {reimbursement.member_description}
        </span>
      </Table.Cell>
      <Table.Cell>
        {
          reimbursement.purpose === 'premium'
            ? <TransactionCategoryBadge category='insurance_premium' />
            : <TransactionCategoryBadge category='healthcare_expense' />
        }
      </Table.Cell>
      <Table.Cell>
        <div className='flex justify-end'>
          {
            reimbursement.amount
              ? (
                <span className={getMoneyClasses(reimbursement.amount)}>
                  {getMoneyText(reimbursement.amount)}
                </span>
                )
              : '-'
          }
        </div>
      </Table.Cell>
    </Table.Row>
  )
}

export const MobileReimbursementRow: React.FC<{ reimbursement: MemberReimbursement }> = ({ reimbursement }) => {
  const { assign } = useWindowLocation()

  return (
    <div
      className='flex flex-col w-full gap-2 py-3 border-t border-gray-200 cursor-pointer'
      onClick={() => assign(membersReimbursements.show({ id: reimbursement.id }))}
      aria-label={`View details for reimbursement ${reimbursement.id}`}
    >
      <div className='flex flex-row w-full justify-between items-start'>
        <div className='flex flex-col gap-1'>
          <div className='body-bold text-main'>
            {reimbursement.member_description}
          </div>
          <span className='body-sm text-gray-500'>
            Pending
          </span>
          {!reimbursement.has_receipts && (
            <span className='caption font-semibold text-red-400'>
              Missing receipt
            </span>
          )}
        </div>
        <div>
          {
            reimbursement.amount
              ? (
                <span className={getMoneyClasses(reimbursement.amount)}>
                  {getMoneyText(reimbursement.amount)}
                </span>
                )
              : '-'
          }
        </div>
      </div>
      <span className='body text-main'>
        {
          reimbursement.purpose === 'premium'
            ? <TransactionCategoryBadge category='insurance_premium' />
            : <TransactionCategoryBadge category='healthcare_expense' />
        }
      </span>
    </div>
  )
}
